import { SetStateAction } from 'react';
import { toast } from 'react-toastify';

import { InterPrise, UserPlatform } from '../../interfaces';
import { LocaState } from '../../store/ducks/locais/types';
import axiosCommon from '../axiosServicesDataCommon';
import axiosPlace from '../axiosServicesLocais';
import axiosScheduling from '../axiosServicesAgendamentos';
import axios from '../axiosServicesUsers';

async function GetUsers() {
  const response = await axios.get('admin/usuarios/v1');
  return response;
}
async function GetUserLog(idUsuarioLogReserva: string) {
  const response = await axiosScheduling.get(`/admin/agendas/reserva-posicao/v1/logs/${idUsuarioLogReserva}`);
  return response;
}
async function GetRegionais() {
  const response = await axiosCommon.get('regionais');
  return response;
}
async function GetAccessLevel() {
  const response = await axios.get('admin/usuarios/v1/perfis-acesso');
  return response;
}
async function GetPlaces() {
  const response = await axiosPlace.get('admin/locais/v1/locais-validos');
  return response;
}
async function GetCorretor(idRegional: string) {
  const response = await axiosCommon.get(`corretores/${idRegional}`);
  return response;
}
async function UpdatePlace(
  id: string,
  status: boolean,
  setData: SetStateAction<any>,
  data: Array<UserPlatform>,
) {
  if (status) {
    await axios.put(`admin/usuarios/v1/desativar/${id}`);
    toast.success('Usuário desativado com sucesso!');
  } else {
    await axios.put(`admin/usuarios/v1/ativar/${id}`);
    toast.success('Usuário ativado com sucesso!');
  }
  setData(
    data.map((item) => {
      if (item.id === id) {
        item.ativo = !item.ativo;
        return item;
      }
      return item;
    }),
  );
}

async function SaveOrEdit(
  isEdit: boolean,
  email: string,
  idUser: string,
  name: string,
  lastName: string,
  sigla: string,
  isAdmin: boolean,
  isMobile: boolean,
  regionalSelect: string,
  typeAcess: string,
  phone: string,
  locais: Array<LocaState>,
  enterprise: Array<InterPrise>,
  setIsEdit: SetStateAction<any>,
  clearState: SetStateAction<any>,
  unCheck: SetStateAction<any>,
  setIdUser: SetStateAction<any>,
  setOpenModal: SetStateAction<any>,
  setPhone: SetStateAction<any>,
  requestPlaces: () => void,
  isPlace: boolean,
  isSpecialist: boolean,
  setLoadingSave: SetStateAction<any>,
  isVisit: boolean,
  requestUsers: () => void,
  idCorretor: string,
) {
  try {
    setLoadingSave(true);
    if (isEdit) {
      await axios.put(`admin/usuarios/v1/${idUser}`, {
        primeiroNome: name,
        sobrenome: lastName,
        email,
        siglaNome: sigla,
        acessoAdmin: isAdmin,
        acessoMobile: isMobile,
        idCorretor,
        codigoRegional: regionalSelect,
        idPerfilAcesso: typeAcess,
        celular: phone,
        idsLocais: isPlace
          ? locais?.filter((item) => item.check).map((item) => item.idLocal)
          : null,
        idsEmpreendimentos: isSpecialist
          ? enterprise
            ?.filter((item) => item.check)
            .map((item) => item.idEmpreendimento)
          : null,
        acompanharVisita: isPlace ? isVisit : false,
      });

      toast.success('Usuário atualizado com sucesso!');
      setLoadingSave(false);
      setIsEdit(false);
      clearState();
      unCheck();
      setOpenModal(false);
      setIdUser('');
      setPhone('');
      requestUsers();
      return;
    }
    await axios.post('admin/usuarios/v1', {
      primeiroNome: name,
      sobrenome: lastName,
      email,
      siglaNome: sigla,
      acessoAdmin: isAdmin,
      acessoMobile: isMobile,
      codigoRegional: regionalSelect,
      idCorretor,
      idPerfilAcesso: typeAcess,
      celular: phone,
      idsLocais: isPlace
        ? locais?.filter((item) => item.check).map((item) => item.idLocal)
        : null,
      idsEmpreendimentos: isSpecialist
        ? enterprise
          ?.filter((item) => item.check)
          .map((item) => item.idEmpreendimento)
        : null,
      acompanharVisita: isPlace ? isVisit : false,
    });
    setLoadingSave(false);
    toast.success('Usuário salvo com sucesso!');
    clearState();
    unCheck();
    requestPlaces();
    requestUsers();
  } catch (error: any) {
    setLoadingSave(false);
    toast.error(
      `⚠ ${error.response.data?.notifications?.map(
        (item: any) => `${item.message}\n`,
      )}`,
    );
  }
}

export default {
  GetUsers,
  GetUserLog,
  GetRegionais,
  GetAccessLevel,
  GetCorretor,
  GetPlaces,
  UpdatePlace,
  SaveOrEdit,
};
